import component from './vi-VN/component';
import common from './vi-VN/common';
import globalHeader from './vi-VN/globalHeader';
import menu from './vi-VN/menu';
import pages from './vi-VN/pages';
import pwa from './vi-VN/pwa';
import settingDrawer from './vi-VN/settingDrawer';
import settings from './vi-VN/settings';
import analytics from './vi-VN/analytics';
import salescard from './vi-VN/salescard';
import analysisOthers from './vi-VN/analysisOthers';
import topsearch from './vi-VN/topsearch';
import proportionsales from './vi-VN/proportionsales';
import offlinedata from './vi-VN/offlinedata';
import monitor from './vi-VN/monitor';
import mission from './vi-VN/mission';
import miner from './vi-VN/miner';
import user_management from './vi-VN/user_management';
import leaderboard from './vi-VN/leaderboard';
import translation from './vi-VN/translation';
import wallet from './vi-VN/wallet';
import dashboard from './vi-VN/dashboard';
import notification from './vi-VN/notification';

const localLocales = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('app_translations') || '{}') : {};

export default {
  'navBar.lang': 'Languages',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Terms',
  'app.preview.down.block': 'Download this page to your local project',
  'app.welcome.link.fetch-blocks': 'Get all block',
  'app.welcome.link.block-list':
    'Quickly build standard, pages based on `block` development',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...common,
  ...pages,
  ...analytics,
  ...salescard,
  ...analysisOthers,
  ...topsearch,
  ...proportionsales,
  ...offlinedata,
  ...monitor,
  ...user_management,
  ...mission,
  ...leaderboard,
  ...translation,
  ...wallet,
  ...dashboard,
  ...notification,
  ...miner,
  ...(localLocales.vi || {})
};
